module.exports = __webpack_public_path__ + "img/Inside-sp_15.4d6be9d4.jpg";